import {
  getLineItemsOfSelectedOrder,
  getOrderId,
  getOrderingSystem,
  getSelectedLineItems,
  getSelectedOrder,
  getSelectedShop,
} from '../../selectors/tools';
import {
  extractSelectedTicketIdFromState,
  getAllOrdersFromOrdersSearch,
  getselectedConversationId,
  getSimplrAccountIdOfSelectedTicket,
} from '../../extractFromState';
import { formatOrderItemsToRefund } from '../../util';
import { getSimplrExpertPtrId } from '../../api/expert';
import { selectRefundAmount } from '../../selectors/partialRefund';
import { partialRefundSelectedItems } from './CommonOrderActions';
import {
  PARTIAL_REFUND_RESET,
  PARTIAL_REFUND_SET_AMOUNT,
  PROCESS_PARTIAL_REFUND_FULFILLED,
  PROCESS_PARTIAL_REFUND_PENDING,
  PROCESS_PARTIAL_REFUND_REJECTED,
} from '../../reducers/tools/decisionTree/partialRefund';
import { setOrders } from './OrdersSearchActions';
import cloneDeep from 'lodash/cloneDeep';

export const partialRefundPending = () => {
  return {
    type: PROCESS_PARTIAL_REFUND_PENDING,
  };
};

export const partialRefundFulfilled = () => {
  return {
    type: PROCESS_PARTIAL_REFUND_FULFILLED,
  };
};

export const partialRefundRejected = (error) => {
  return {
    type: PROCESS_PARTIAL_REFUND_REJECTED,
    error,
  };
};

export const resetPartialRefundStore = () => {
  return {
    type: PARTIAL_REFUND_RESET,
  };
};

export const setPartialRefundAmount = (amount) => {
  return {
    type: PARTIAL_REFUND_SET_AMOUNT,
    amount,
  };
};

export const processPartialRefund = () => async (dispatch, getState) => {
  const state = getState();

  const selectedOrder = getSelectedOrder(state);
  const userSelectedItems = getSelectedLineItems(state);
  const lineItemsOfSelectedOrder = getLineItemsOfSelectedOrder(state);
  const simplrAccountId = getSimplrAccountIdOfSelectedTicket(state);
  const shopName = getSelectedShop(state);
  const shopType = getOrderingSystem(state);
  const orderId = getOrderId(selectedOrder, shopType);
  const selectedItems = userSelectedItems.length ? userSelectedItems : lineItemsOfSelectedOrder;
  const refundItems = formatOrderItemsToRefund(shopType, selectedItems);
  const selectedTicketId = extractSelectedTicketIdFromState(state);
  const conversationId = getselectedConversationId(state);
  const userId = getSimplrExpertPtrId();
  const amount = selectRefundAmount(state);
  const allOrders = cloneDeep(getAllOrdersFromOrdersSearch(state));

  const options = {
    amount: amount.toFixed(2),
    simplrAccountId,
    conversationId,
    selectedTicket: selectedTicketId,
    orderId: String(orderId),
    userId,
    refundItems,
    shopType,
    shopName,
    comment: 'Order items partially refunded upon customer request',
    addNotes: true,
  };

  dispatch(partialRefundPending());
  const response = await dispatch(partialRefundSelectedItems(options));
  const orderToUpdateIndex = allOrders.findIndex((order) => order.id === orderId);
  allOrders[orderToUpdateIndex].financial_status = 'partially_refunded';
  dispatch(setOrders(allOrders));
  dispatch(partialRefundFulfilled(response));
};
